import { connect } from 'react-redux'
import { setWizards } from 'core/components/wizard/actions'
import { setStock } from '../actions'
import Congratulations from './Congratulations'

const mapStateToProps = state => ({
  wizards: state.wizards,
  stock: state.stock
})

const mapDispatchToProps = {
  setWizards,
  setStock
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Congratulations)
